import React from 'react';

interface MagicMascotProps {
  style?: React.CSSProperties;
  className?: string;
}

export const MagicMascot: React.FC<MagicMascotProps> = ({
  style,
  className,
}) => (
  <svg
    viewBox="0 0 32 32"
    width="1em"
    height="1em"
    style={style}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="magic-gem" x1="0" y1="0" x2="0.3" y2="1">
        <stop offset="0%" stopColor="#a78bfa" />
        <stop offset="50%" stopColor="#7c3aed" />
        <stop offset="100%" stopColor="#5b21b6" />
      </linearGradient>
      <radialGradient id="magic-inner" cx="0.4" cy="0.35">
        <stop offset="0%" stopColor="white" stopOpacity="0.9" />
        <stop offset="40%" stopColor="#c4b5fd" stopOpacity="0.4" />
        <stop offset="100%" stopColor="#7c3aed" stopOpacity="0" />
      </radialGradient>
      <filter id="magic-glow">
        <feGaussianBlur stdDeviation="1.5" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    {/* Crystal body */}
    <polygon
      points="16,3 24,13 20,29 12,29 8,13"
      fill="url(#magic-gem)"
      stroke="#5b21b6"
      strokeWidth="0.6"
      filter="url(#magic-glow)"
    />
    {/* Facet lines */}
    <line
      x1="16"
      y1="3"
      x2="12"
      y2="29"
      stroke="#a78bfa"
      strokeWidth="0.4"
      opacity="0.5"
    />
    <line
      x1="16"
      y1="3"
      x2="20"
      y2="29"
      stroke="#a78bfa"
      strokeWidth="0.4"
      opacity="0.5"
    />
    <line
      x1="8"
      y1="13"
      x2="24"
      y2="13"
      stroke="#a78bfa"
      strokeWidth="0.4"
      opacity="0.5"
    />
    {/* Inner glow */}
    <polygon points="16,3 24,13 20,29 12,29 8,13" fill="url(#magic-inner)" />
    {/* Sparkle rays */}
    <line
      x1="4"
      y1="8"
      x2="6"
      y2="10"
      stroke="#fbbf24"
      strokeWidth="1"
      strokeLinecap="round"
      opacity="0.8"
    />
    <line
      x1="26"
      y1="6"
      x2="24"
      y2="8"
      stroke="#fbbf24"
      strokeWidth="1"
      strokeLinecap="round"
      opacity="0.8"
    />
    <line
      x1="3"
      y1="20"
      x2="5.5"
      y2="19"
      stroke="#fbbf24"
      strokeWidth="1"
      strokeLinecap="round"
      opacity="0.6"
    />
    <line
      x1="27"
      y1="22"
      x2="24.5"
      y2="21"
      stroke="#fbbf24"
      strokeWidth="1"
      strokeLinecap="round"
      opacity="0.6"
    />
    {/* Sparkle dots */}
    <circle cx="5" cy="5" r="0.8" fill="white" opacity="0.7" />
    <circle cx="28" cy="18" r="0.6" fill="white" opacity="0.5" />
    <circle cx="2" cy="15" r="0.5" fill="#fbbf24" opacity="0.6" />
  </svg>
);
